// extracted by mini-css-extract-plugin
export default {"dropdown":"InlineLangSelector_dropdown__Z6s32","hide-last":"InlineLangSelector_hide-last__1zV8x"};